export default __webpack_public_path__ + "static/media/logo.6161b09e.png";